const statementsEN = {
    "view": {
        "table": {
            "title": "Your Statements list",
            "column": {
                "type": "Type",
                "year": "Year",
                "month": "Month",
                "issue_year": "Is. Year",
                "issue_month": "Is. Month",
                "description": "Description",
                "amount": "Amount",
                "status": "Status",
                "details": "Details",
                "overview": "Overview",
            },
            "placeholder": {
                "search": "Search..."
            },
            "label": {
                "status_open": "Open",
                "status_paid": "Paid",
                "type_licensing": "Licensing",
                "type_regular": "Regular",
                "type_audio_mastering_services": "Audio Mastering - Services",
                "type_vinyl_earnings": "Vinyl Earnings",
                "type_offset": "Offset",
                "type_escrow_refund": "Escrow Refund",
                "type_not_known": "Not Known",
                "month_january": "January",
                "month_february": "February",
                "month_march": "March",
                "month_april": "April",
                "month_may": "May",
                "month_june": "June",
                "month_july": "July",
                "month_august": "August",
                "month_september": "September",
                "month_october": "October",
                "month_november": "November",
                "month_december": "December"
            },
            "button": {
                "download": "Download",
                "exportCsv": "Export CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        }
    },
};

export default statementsEN;